import MoreRoundIcon from "./images/icons/moreRoundIcon.svg?react";
import "./MoreRoundButton.scss";

interface IMoreRoundButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const MoreRoundButton: React.FC<IMoreRoundButtonProps> = ({
  onClick
}) => {
  return (
    <button onClick={(event) => onClick(event)} className="MoreRoundButton" title="Show more actions" aria-label="show more button">
      <MoreRoundIcon />
    </button>
  );
};
